// Chat bubble color palette and helpers
// Colors chosen for mid-contrast backgrounds that work in light/dark themes.

export const CHAT_BUBBLE_COLORS = [
  '#EF4444', // red
  '#F97316', // orange
  '#F59E0B', // amber
  '#EAB308', // yellow
  '#A3E635', // lime
  '#84CC16', // green-lime
  '#22C55E', // green
  '#10B981', // emerald
  '#2DD4BF', // aquamarine
  '#06B6D4', // cyan
  '#0EA5E9', // light blue
  '#38BDF8', // sky
  '#2563EB', // indigo-blue
  '#6366F1', // indigo
  '#7C3AED', // violet
  '#8B5CF6', // light violet
  '#9333EA', // purple
  '#C084FC', // pastel purple
  '#D946EF', // fuchsia
  '#EC4899', // pink
  '#F43F5E', // rose
  '#FB7185', // light rose
  '#FCA5A5', // soft red
  '#FDBA74', // soft orange
  '#FCD34D', // soft yellow
  '#9CA3AF', // gray (neutral)
  '#94A3B8', // slate (neutral)
  '#DC2626', // red-600
  '#EA580C', // orange-600
  '#D97706', // amber-600
  '#CA8A04', // yellow-600
  '#65A30D', // lime-600
  '#16A34A', // green-600
  '#059669', // emerald-600
  '#0D9488', // teal-600
  '#0891B2', // cyan-600
  '#0284C7', // sky-600
  '#1D4ED8', // blue-700
  '#4F46E5', // indigo-600
  '#6D28D9', // violet-700
  '#7E22CE', // purple-700
  '#C026D3', // fuchsia-600
  '#DB2777', // pink-600
  '#E11D48', // rose-600
  '#F472B6', // pink-400
  '#FB923C', // orange-400
  '#4ADE80', // green-400
  '#34D399', // emerald-400
  '#22D3EE', // cyan-400
  '#60A5FA', // blue-400
  '#818CF8', // indigo-400
  '#A78BFA', // violet-400
  '#E879F9', // fuchsia-400
  '#F9A8D4', // pink-300 soft
  '#6EE7B7', // emerald-300 soft
  '#7DD3FC', // sky-300 soft
  '#C4B5FD', // violet-300 soft
] as const;

export type ChatBubbleColor = (typeof CHAT_BUBBLE_COLORS)[number];

function hashString(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }
  return Math.abs(hash);
}

/**
 * Pick a stable color from the palette. If a seed is provided, selection
 * is deterministic; otherwise falls back to a random choice.
 */
export function pickChatBubbleColor(seed?: string): ChatBubbleColor {
  if (!seed) {
    const randomIndex = Math.floor(Math.random() * CHAT_BUBBLE_COLORS.length);
    return CHAT_BUBBLE_COLORS[randomIndex];
  }
  const index = hashString(seed) % CHAT_BUBBLE_COLORS.length;
  return CHAT_BUBBLE_COLORS[index];
}
